import { Platform } from "react-native"
import messaging from "@react-native-firebase/messaging"
import { check, request, PERMISSIONS, RESULTS } from "react-native-permissions"
import { onUpdateFCMToken } from "./api"

export const getMobileFCMToken = async (accessToken, memberId) => {
  try {
    let permissionStatus
    let enabled = false

    if (Platform.OS === "android") {
      permissionStatus = await check(PERMISSIONS.ANDROID.POST_NOTIFICATIONS)

      if (permissionStatus === RESULTS.DENIED || permissionStatus === RESULTS.BLOCKED) {
        permissionStatus = await request(PERMISSIONS.ANDROID.POST_NOTIFICATIONS)
      }

      enabled = permissionStatus === RESULTS.GRANTED
    } else if (Platform.OS === "ios") {
      const authStatus = await messaging().requestPermission()
      enabled =
        authStatus === messaging.AuthorizationStatus.AUTHORIZED ||
        authStatus === messaging.AuthorizationStatus.PROVISIONAL
    }

    if (enabled) {
      const fcmToken = await messaging().getToken()

      if (!fcmToken) {
        throw new Error("FCM token not available")
      }

      await onUpdateFCMToken(accessToken, memberId, fcmToken)

      return fcmToken
    } else {
      return null
    }
  } catch (error) {
    console.error("Error checking notification permissions:", error)
    throw error
  }
}
